<template>
  <div class="chart-container">
    <Bar v-if="chartData.labels.length > 0" :data="chartData" :options="chartOptions" />
    <div v-else class="text-center text-muted py-5">جاري تحميل البيانات...</div>
  </div>
</template>

<script>
// 1. استيراد المكونات الضرورية من المكتبتين
import { Bar } from 'vue-chartjs'
import { 
  Chart as ChartJS, 
  Title, 
  Tooltip, 
  Legend, 
  BarElement, 
  CategoryScale, 
  LinearScale 
} from 'chart.js'

// 2. تسجيل الأدوات (هذه الخطوة هي الأهم ولن يعمل بدونها)
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'GradesChart',
  components: { Bar },
  props: {
    // استقبال البيانات من الصفحة الأب
    chartData: {
      type: Object,
      required: true,
      default: () => ({ labels: [], datasets: [] })
    }
  },
  data() {
    return {
      // إعدادات شكل الرسم البياني
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false, // ليتمدد حسب حجم الكارد
        plugins: {
          legend: { display: false }, // إخفاء مفتاح الرسم لأن الألوان واضحة
          title: {
            display: true,
            text: 'توزيع الطلاب حسب فئات المجموع',
            font: { size: 16, family: 'Cairo' }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: 'عدد الطلاب' }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px; /* ضروري جداً تحديد ارتفاع */
  width: 100%;
}
</style>